import buildTeamLogo from "../../../assets/images/build-team-section-logo.jpg";
import appStoreBadge from "../../../assets/images/appstorebuild.png";
import playStoreBadge from "../../../assets/images/playstorebuild.png";

export const BuildTeamConstants = {
  logo: buildTeamLogo,
  heading: "Ready to build your team with us?",
  description:
    "Play around with it first. Pay and add your team later. Download Our app for free",
  appStores: [
    {
      type: "appstore",
      image: appStoreBadge,
      name: "App Store",
      link: "https://apps.apple.com/app/cric-center",
    },
    {
      type: "playstore",
      image: playStoreBadge,
      name: "Google Play",
      link: "https://play.google.com/store/apps/details?id=com.criccenter",
    },
  ],
};
